var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"chatList",staticClass:"chat-list-msg",on:{"scroll":_vm.onScrollChat}},[_c('span',[_vm._v(_vm._s(_vm.title))]),_vm._l((_vm.items),function(item){return _c('ChartListItem',{key:item.id,attrs:{"item":item,"username":_vm.username,"is-admin":_vm.isAdmin,"is-past":_vm.isPast,"reply-msg":_vm.getReplyMsg(item.id_reply)}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }